<template>
  <div>
    <!-- Definition Component Tabs -->
    <Tabs :tabs="tabs" @change="changeTab($event)" :tabSelected="tabSelected" />

    <!-- Tab - Parameters -->
    <div class="col-12 px-3" v-if="tabSelected == 1">
      <!-- Option -> Status -->
      <div class="row my-2 px-2">
        <div class="col-12">
          <span class="mr-3">{{ $t("lang.column.status") }}:</span>
          <div class="d-inline" v-if="targetDetail.target_status_id == 1">
            <span class="badge badge-primary text-white px-3 py-2">
              {{ $t("lang.targets.active") }}
            </span>
            <Tooltip
              :text="$t('lang.orders.status_prepare_tooltip')"
              :width="''"
            >
              <div
                class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
              >
                <div class="question-mark text-white">?</div>
              </div>
            </Tooltip>
          </div>

          <div class="d-inline" v-if="targetDetail.target_status_id == 2">
            <span class="badge badge-danger text-white px-3 py-2">
              {{ $t("lang.targets.stopped") }}</span
            >
            <Tooltip
              :text="$t('lang.orders.status_inactive_tooltip')"
              :width="''"
            >
              <div
                class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
              >
                <div class="question-mark text-white">?</div>
              </div>
            </Tooltip>
          </div>

          <div class="d-inline" v-if="targetDetail.target_status_id == 3">
            <span class="badge badge-secondary text-white px-3 py-2">
              {{ $t("lang.targets.pending") }}</span
            >
            <Tooltip :text="$t('lang.orders.status_draft_tooltip')" :width="''">
              <div
                class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
              >
                <div class="question-mark text-white">?</div>
              </div>
            </Tooltip>
          </div>

          <div class="d-inline" v-if="targetDetail.target_status_id == 4">
            <span class="badge badge-success text-white px-3 py-2">
              {{ $t("lang.targets.running") }}</span
            >
            <Tooltip
              :text="$t('lang.orders.status_active_tooltip')"
              :width="''"
            >
              <div
                class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
              >
                <div class="question-mark text-white">?</div>
              </div>
            </Tooltip>
          </div>

          <div class="d-inline" v-if="targetDetail.target_status_id == 5">
            <span class="badge badge-warning text-white px-3 py-2">
              {{ $t("lang.targets.archived") }}</span
            >
            <Tooltip
              :text="$t('lang.orders.status_achived_tooltip')"
              :width="''"
            >
              <div
                class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
              >
                <div class="question-mark text-white">?</div>
              </div>
            </Tooltip>
          </div>
          <!-- <span
              v-if="targetDetail.target_status_id == 6"
              class="badge badge-warning text-white px-3 py-2"
            >
              {{ $t("lang.targets.paused") }}</span
            > -->
        </div>
      </div>

      <!-- Option -> Language -->
      <div class="row my-4 px-2">
        <div class="col-12">
          <label for="staticEmail" class="h6 mr-4">
            {{ $t("lang.label.language") }}:
          </label>
          <button
            type="button"
            @click="showFlag = true"
            :disabled="true"
            class="btn btn-light px-0 py-0 my-0 mx-0"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span
              class="input-group-text px-1 py-1"
              style="background-color: white"
            >
              {{ getLangSelected }}
              <img
                width="25"
                :src="flagActually(getIdLangSelected)"
                class="flag ml-3 mr-2"
              />
            </span>
          </button>

          <div class="dropdown-menu dropdown-menu-left">
            <button
              v-for="(lang, i) of langs"
              class="dropdown-item"
              type="button"
              :key="i"
              @click="changeLanguage(lang.id)"
            >
              <div class="row">
                <div class="col-8">
                  <span class="ml-0 small">{{ lang.label }}</span>
                </div>
                <div class="col-4">
                  <img
                    :src="flagActually(lang.id)"
                    class="flag2 mr-3"
                    width="25"
                  />
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>

      <!-- Option -> Appointment Volume -->
      <div class="row my-4 px-2">
        <div class="col-12">
          <span v-if="!isOpen('appointment')" class="mr-4">
            <span class="mr-4 h6">
              {{ $t("lang.onBoarding.expected_value_appointments") }}:
              <Tooltip :text="$t('lang.orders.meet_month_tooltip')" :width="''">
                <div
                  class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
                >
                  <div class="question-mark text-white">?</div>
                </div>
              </Tooltip>
            </span>
            <b class="text-primary">{{ targetDetail.appt_quantity }}</b>
            /
            {{ $t("lang.label.month") }}
          </span>
          <span v-else-if="isOpen('appointment')" class="font-weight-bold mr-4">
            <span class="bg-white border-0 pl-0 ml-3"
              >{{ $t("lang.onBoarding.expected_value_appointments") }}
            </span>
            <span class="mx-4">
              <div class="wrapper">
                <input
                  min="10"
                  max="100"
                  class="form-control"
                  type="number"
                  v-model="targetDetail.appointmentVolume"
                  @input="changeAppointmentVolume"
                />
              </div>
            </span>

            <span class="bg-white border-0 pl-0 pt-0">
              / {{ $t("lang.label.month") }}
            </span>
          </span>
        </div>
        <div class="col-12 my-0 py-0"></div>
      </div>

      <!-- Option -> Launch Date -->
      <div class="row my-4 px-2">
        <div class="col-12">
          <span v-if="!isOpen('launchDate')">
            <span class="mr-4 h6">
              {{ $t("lang.onBoarding.launch_date_campaign") }}:
              <i class="text-danger">*</i>
              <Tooltip :text="$t('lang.orders.start_send_tooltip')" :width="''">
                <div
                  class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
                >
                  <div class="question-mark text-white">?</div>
                </div>
              </Tooltip>
            </span>
            <span v-if="targetDetail.launch_date_campaign">
              {{ targetDetail.launch_date_campaign.substr(0, 10) }}
            </span>
          </span>
          <span v-else-if="isOpen('launchDate')">
            <span class="bg-white border-0 pl-0"
              >{{ $t("lang.onBoarding.launch_date_campaign") }}:
            </span>
            <vue-form-generator
              class="d-inline-block mx-4"
              ref="launchDateForm"
              :schema="schemaStatus"
              :model="modelform"
              :options="formOptions"
            ></vue-form-generator>
          </span>
        </div>
      </div>

      <!-- Option -> Price -->
      <div class="row my-4 px-2">
        <div class="col-12">
          <span v-if="!isOpen('editingAppointPrice')">
            <span class="mr-4 h6"
              >{{ $t("lang.onBoarding.my_price_appointment") }}:
              <Tooltip :text="$t('lang.onBoarding.not_taxes')" :width="''">
                <div
                  class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
                >
                  <div class="question-mark text-white">?</div>
                </div>
              </Tooltip>
            </span>
            <span class="text-primary">

              <span v-if="targetDetail.appt_price && specialOrderDiscountCountDown != '' && targetDetail.target_status_id == 3">
                <span class="tachar">{{ targetDetail.appt_price }} €</span>

                <span class="text-red ml-3"
                  >{{ getOrderPriceWithDiscount(targetDetail.appt_price) }} €  / {{ $t("lang.label.meeting") }}</span
                >
              </span>
              <span v-else>
                {{ targetDetail.appt_price }} € / {{ $t("lang.label.meeting") }}
              </span>
            </span>
            <!-- <b class="text-primary ml-1" v-if="false">
                ({{
                  $t("lang.onBoarding.prospects", {
                    prospects: new Intl.NumberFormat("es-ES").format(
                      onBoarding.apollo.total_result
                    )
                  })
                }})
              </b> -->
          </span>
          <span v-else-if="isOpen('editingAppointPrice')">
            <span class="bg-white border-0 pl-0"
              >{{ $t("lang.onBoarding.my_price_appointment") }}
            </span>

            <span class="mx-2">
              <div class="wrapper">
                <input
                  min="1"
                  max="500"
                  class="form-control"
                  type="number"
                  :value="targetDetail.appointmentPrice"
                  @input="changeAppointmentPrice"
                />
              </div>
            </span>
          </span>
        </div>
      </div>

      <!-- List the sales -->
      <div class="card my-4 p-3">
        {{ $t("lang.onBoarding.who_is_thesales") }}
        <LoadingSpinner v-if="loadingSales" />
        <IndustrySearch
          :isDisabled="true"
          v-if="!loadingSales"
          :option_list="salesRep"
          :default_values="salesSelected"
        />
        <small class="text-danger my-3" v-if="salesRep.length == 0">
          {{ $t("lang.orders.unavailablesales") }}</small
        >
      </div>

      <!-- Description -->
      <div class="col-12">
        {{ $t("lang.column.description") }}:
        <p>
          <textarea
            class="form-control"
            name=""
            rows="3"
            :value="targetDetail.description_order"
            :disabled="true"
          >
          </textarea>
        </p>
      </div>
    </div>

    <!-- Tab - Services -->
    <div class="col-12 px-4 pt-2" v-if="tabSelected == 2">
      <!-- Option > Company Name (input) -->
      <div class="row mx-1">
        <div class="col-12 d-flex justify-content-start px-0">
          <span class="d-flex align-items-end">
            {{
              $t(
                "lang.onBoarding.step1_1_question"

              )
            }}

            <i class="ml-1 text-danger">*</i>
          </span>
          <input
            class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
            maxlength="300"
            type="text"
            :value="targetDetail.product_name"
            :disabled="true"
            :placeholder="
              $t('lang.onBoarding.example') +
              ': Oliverlist'
            "
          />
        </div>
      </div>
      <!-- Opction > Website (input)-->
      <div class="row px-3">
        <div class="col-12 d-flex justify-content-start px-0 py-0 my-0">
          <span class="d-flex align-items-end">
            {{
              $t(
                "lang.onBoarding.step3_website",
              )
            }}
            <i class="ml-1 text-danger">*</i>
          </span>
          <input
            @focus="editingUrl = true"
            @blur="editingUrl = false"
            class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
            maxlength="150"
            type="text"
            :value="targetDetail.landing_page"
            :disabled="true"
            :placeholder="
              $t('lang.onBoarding.example') +
              ': http://www.oliverlist.com'
            "
          />
        </div>
      </div>
      <!-- Opction > Offer prospect (select) -->
      <div class="mt-3">
        <span class="">
          {{
            $t(
              "lang.onBoarding.step1_3_question",

            )
          }}
          <i class="ml-1 text-danger">*</i>
        </span>

        <span class="ml-2">
          <select
            v-model="targetDetail.offer_prospect"
            class="d-inline form-control text-size-14"
            :disabled="true"
          >
            <option
              v-for="offer in select_offer_prospect"
              :key="offer.id"
              :value="offer.id"
              class="optionSelect"
            >
              {{ offer.label }}
            </option>
          </select>
        </span>
      </div>

      <!-- Opction > Description Sell (input) -->
      <div class="row px-3">
        <div class="col-12 d-flex justify-content-start px-0">
          <span class="d-flex align-items-end">
            {{
              $t(
                "lang.onBoarding.description_sell_prepend",

              ).replace("[]", targetDetail.product_name)
            }}
            <i class="ml-1 text-danger">*</i>
          </span>

          <input
            class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
            maxlength="150"
            ref="inputOne"
            type="text"
            :value="targetDetail.description_sell"
            :disabled="true"
            @focus="openEdit('descriptionSell')"
            @blur="closeEdit('descriptionSell')"
            :placeholder="
              $t(
                'lang.onBoarding.step1_4_1_example',

              )
            "
          />
        </div>
      </div>
      <span class="col-12 text-center mt-2" v-if="isOpen('descriptionSell')">
        {{
          $t(
            "lang.label.charactersavailable",
            lang,
            { actual: onBoarding.descriptionSell.length, total: 150 }
          )
        }}
      </span>
      <!-- Opction > Avantages (text) -->
      <div class="mt-4">
        <span>
          <span class="">
            {{
              $t(
                "lang.onBoarding.step1_6_question",

              ).replace("[]", targetDetail.product_name)
            }}
            <i class="ml-1 text-danger">*</i>
          </span>
        </span>

        <div class="col-12 mt-3">
          <div class="row">
            <div class="col-12 d-flex justify-content-start px-0">
              <span class="d-flex align-items-end">1.</span>
              <input
                @focus="showMessage(5, 'enable', 0)"
                @blur="showMessage(5, 'disable', 0)"
                class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
                maxlength="300"
                type="text"
                :disabled="true"
                :value="
                  targetDetail.questions.data.find((e) => e.question === 5)
                    .answers[0].text
                "
                @input="changeQuestions($event, 5, 1)"
                :placeholder="
                  $t(
                    'lang.onBoarding.step1_6_item_example1',

                  )
                "
              />
            </div>
          </div>
        </div>

        <div class="col-12 mt-3">
          <div class="row">
            <div class="col-12 d-flex justify-content-start px-0">
              <span class="d-flex align-items-end">2.</span>
              <input
                @focus="showMessage(5, 'enable', 1)"
                @blur="showMessage(5, 'disable', 1)"
                class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
                maxlength="300"
                :disabled="true"
                type="text"
                :value="
                  targetDetail.questions.data.find((e) => e.question === 5)
                    .answers[1].text
                "
                @input="changeQuestions($event, 5, 2)"
                :placeholder="
                  $t(
                    'lang.onBoarding.step1_6_item_example2',

                  )
                "
              />
            </div>
          </div>
        </div>

        <div class="col-12 mt-2">
          <div class="row">
            <div class="col-12 d-flex justify-content-start px-0">
              <span class="d-flex align-items-end">3.</span>
              <input
                :disabled="true"
                @focus="showMessage(5, 'enable', 2)"
                @blur="showMessage(5, 'disable', 2)"
                class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
                maxlength="300"
                type="text"
                :value="
                  targetDetail.questions.data.find((e) => e.question === 5)
                    .answers[2].text
                "
                @input="changeQuestions($event, 5, 3)"
                :placeholder="
                  $t(
                    'lang.onBoarding.step1_6_item_example3',

                  )
                "
              />
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <span>
          <span class="">
            {{
              $t(
                "lang.onBoarding.step1_7_question",

              ).replace("[]", this.$store.state.onboarding.productName)
            }}
            <i class="ml-1 text-danger">*</i>
          </span>
        </span>

        <div class="col-12 mt-2">
          <div class="row">
            <div class="col-12 d-flex justify-content-start px-0">
              <span class="d-flex align-items-end">1.</span>
              <input
                :disabled="true"
                @focus="showMessage(6, 'enable', 0)"
                @blur="showMessage(6, 'disable', 0)"
                class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
                maxlength="300"
                type="text"
                :value="
                  targetDetail.questions.data.find((e) => e.question === 6)
                    .answers[0].text
                "
                @input="changeQuestions($event, 6, 1)"
                :placeholder="
                  $t(
                    'lang.onBoarding.step1_7_item_example1',
                    this.$store.state.onboarding.lang
                  )
                "
              />
            </div>
          </div>
        </div>
        <div class="col-12 mt-2">
          <div class="row">
            <div class="col-12 d-flex justify-content-start px-0">
              <span class="d-flex align-items-end">2.</span>
              <input
                @focus="showMessage(6, 'enable', 1)"
                @blur="showMessage(6, 'disable', 1)"
                class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
                maxlength="300"
                type="text"
                :value="
                  targetDetail.questions.data.find((e) => e.question === 6)
                    .answers[1].text
                "
                @input="changeQuestions($event, 6, 2)"
                :disabled="true"
                :placeholder="
                  $t(
                    'lang.onBoarding.step1_7_item_example2',
                    this.$store.state.onboarding.lang
                  )
                "
              />
            </div>
          </div>
        </div>
        <div class="col-12 mt-2">
          <div class="row">
            <div class="col-12 d-flex justify-content-start px-0">
              <span class="d-flex align-items-end">3.</span>
              <input
                :disabled="true"
                @focus="showMessage(6, 'enable', 2)"
                @blur="showMessage(6, 'disable', 2)"
                class="w-50 text-primary flex-fill mt-2 mx-2 mb-1 lead pl-2 border-style-dashed text-size-14"
                maxlength="300"
                type="text"
                :value="
                  targetDetail.questions.data.find((e) => e.question === 6)
                    .answers[2].text
                "
                @input="changeQuestions($event, 6, 3)"
                :placeholder="
                  $t(
                    'lang.onBoarding.step1_7_item_example3',
                    this.$store.state.onboarding.lang
                  )
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab - Targeting -->
    <div class="m-0 p-0" v-if="tabSelected == 3">
      <!-- Options > Apollo target -->
      <div class="col-12 p-0 mt-2">
        <div class="p-2 m-0 text-left">
          <div class="row">
            <div class="col-md-5 p-0 border-right">
              <div class="">
                <div class="card-body pt-0 px-3">
                  <!-- @save="savenow(false, false)" -->
                  <Step2SummaryToProporsal
                    :target="targetDetail"
                    :key="step2sum"
                    :poupView="true"
                    @change="refreshTarget($event)"
                    :selectDisable="true"
                    :categoryJobs="categoryJobs"
                  />
                     <!-- <Step2Summary
                    @change="refreshTarget($event)"
                    :key="step2sum"
                    :poupView="true"
                    :selectDisable="disabledEdit()"
                    @save="savenow(false, false)"

                     :selectDisable="true"
                  /> -->
                </div>
              </div>
            </div>
            <div class="col-md-7" v-if="targetDetailData">
              <TargetsModalProporsal
                :key="targetkey"
                :contactkey="targetkey + 1"
                :contacts="apolloResult"
                :target="targetDetail"
                :employess="employess"
                :categoryJobs="categoryJobs"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab - Sequence -->
    <div v-if="tabSelected == 4">
      <div class="row mt-0 mx-0" v-if="!loadingSequence">
        <!-- @click="generateNew()" -->
        <!-- !emptySequence && -->
        <button
          class="btn btn-sm btn-primary ml-3 mt-3 mb-3"
          :disabled="true"
          v-if="
            verificationOrder.status == 1 &&
            modelCampaingStep.tabSelected.id == 3
          "
        >
          {{ $t("lang.orders.generate_example") }}
        </button>

        <div class="col-12 pr-2">
          <div class="card">
            <div class="row">
              <div class="col-12">
                <div class="float-right">
                  <!-- <vue-form-generator
                      ref="annualSubscription"
                      :schema="schemaPreviewTemplate"
                      :model="onBoarding"
                      :options="formOptions"
                    >
                    </vue-form-generator> -->
                </div>
              </div>
            </div>
            <div class="col-12">
              <!-- <PreviewEmail
                  class="p-4"
                  :tag_id="Number(tag_id)"
                  :templateId="1"
                  :resumed="false"
                  :subject="'Re'"
                /> -->
              <div class="row my-4">
                <div class="col-8">
                  <div
                    v-if="
                      !loading &&
                      verificationOrder.status == 1 &&
                      previewTemplate()
                    "
                  >
                    <TargetStepCampaingPreviewProporsal
                      v-if="modelCampaingStep.tabSelected.id == 1"
                      :model="modelCampaingStep"
                      :availableTokens="availableTokens"
                      :preview="true"
                      :availableTokensSelect="availableTokens"
                    />
                    <!-- v-if="!previewEmail" -->

                    <!-- !emptySequence &&
                      campaingTabSelectedId == 3 &&
                      !regenerateEmail" -->

                    <PreviewSequencesEmailProporsal
                      v-else-if="modelCampaingStep.tabSelected.id == 3"
                      :target_id="targetId"
                      class="mt-3"
                      @emptySequence="checkSequence()"
                    />
                    <!-- </div> -->

                    <!-- </div> -->

                    <PreviewEmail
                      class="p-4"
                      :tag_id="Number(tag_id)"
                      :templateId="1"
                      :resumed="true"
                      v-else-if="campaingTabSelectedId == 2"
                      :subject="'Re'"
                    />

                    <LoadingSpinner v-if="loading" />
                    <!-- <PreviewEmail
                        class="p-4"
                        :tag_id="Number(tag_id)"
                        :templateId="1"
                        v-else
                        :resumed="true"
                        :subject="'Re'"
                      /> -->
                  </div>
                  <div v-else class="content-center">
                    <div class="text-center">
                      <div>
                        <img
                          src="@/assets/images/icon_file.png"
                          alt="file"
                          srcset=""
                        />
                      </div>
                      <span class="mt-5">
                        <h6>{{ $t("lang.onBoarding.sequence_info") }}</h6>
                      </span>
                    </div>
                    <div class="text-center" v-if="false">
                      <button
                        @click="goToSubStep(1, 1)"
                        class="btn btn-primary"
                      >
                        {{ $t("lang.onBoarding.gotostep", { step: "1/3" }) }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-4 p-3">
                  <div class="bg-custon-gray rounded p-3">
                    <p class="my-4 mx-2">
                      <span>
                        <img
                          width="35px"
                          class="rounded-circle d-inline"
                          src="@/assets/images/oliver-b-1.png"
                          alt=""
                        />
                      </span>
                      <strong class="ml-2">Tips</strong>
                    </p>
                    <p class="my-3 mx-2 small">
                      <strong>
                        {{
                          $t("lang.orders.sequence_tip_1").substr(
                            0,
                            $t("lang.orders.sequence_tip_1").indexOf(":")
                          )
                        }}
                      </strong>
                      {{
                        $t("lang.orders.sequence_tip_1")
                          .substr($t("lang.orders.sequence_tip_1").indexOf(":"))
                          .replace(
                            /\[(company_name|nombre_de_empresa)]/gi,
                            " " + client.company_name
                          )
                      }}
                    </p>

                    <p class="my-3 mx-2 small">
                      <strong>
                        {{
                          $t("lang.orders.sequence_tip_2").substr(
                            0,
                            $t("lang.orders.sequence_tip_2").indexOf(":")
                          )
                        }}
                      </strong>
                      {{
                        $t("lang.orders.sequence_tip_2")
                          .substr($t("lang.orders.sequence_tip_2").indexOf(":"))
                          .replace(
                            /\[(company_name|nombre_de_empresa)]/gi,
                            client.company_name
                          )
                      }}
                    </p>
                    <p class="my-3 mx-2 small">
                      <strong>
                        {{
                          $t("lang.orders.sequence_tip_3").substr(
                            0,
                            $t("lang.orders.sequence_tip_3").indexOf(":")
                          )
                        }}
                      </strong>
                      {{
                        $t("lang.orders.sequence_tip_3").substr(
                          $t("lang.orders.sequence_tip_3").indexOf(":")
                        )
                      }}
                    </p>
                    <p class="my-3 mx-2 small">
                      <strong>
                        {{
                          $t("lang.orders.sequence_tip_4").substr(
                            0,
                            $t("lang.orders.sequence_tip_4").indexOf(":")
                          )
                        }}
                      </strong>
                      {{
                        $t("lang.orders.sequence_tip_4").substr(
                          $t("lang.orders.sequence_tip_4").indexOf(":")
                        )
                      }}
                    </p>
                    <p class="my-3 mx-2 small">
                      <strong>
                        {{
                          $t("lang.orders.sequence_tip_5").substr(
                            0,
                            $t("lang.orders.sequence_tip_5").indexOf(":")
                          )
                        }}
                      </strong>
                      {{
                        $t("lang.orders.sequence_tip_5").substr(
                          $t("lang.orders.sequence_tip_5").indexOf(":")
                        )
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { proporsalService, adminService } from "@/_services";
import { mapState, mapActions } from "vuex";
import Tabs from "@/components/Common/Tabs.vue";
import Tips from "@/components/Common/Tips.vue";
import Modal from "@/components/Common/Modal.vue";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import TargetsModalProporsal from "@/components/Onboarding/TargetsModalProporsal.vue";
import Step2SummaryToProporsal from "@/components/Onboarding/MultiSteps/Step2SummaryToProporsal.vue";
import Step2Summary from "@/components/Onboarding/MultiSteps/Step2Summary.vue";
import PreviewEmail from "@/components/Emails/PreviewEmail.vue";
import PreviewSequencesEmailProporsal from "@/components/Emails/PreviewSequencesEmailProporsal.vue";
import TargetStepCampaingPreviewProporsal from "@/components/Campaigns/TargetStepCampaingPreviewProporsal.vue";
import { formattersMixin } from "@/_mixins/";

export default {
  name: "ProporsalOrderDetail",
  components: {
    Tabs,
    Tooltip,
    IndustrySearch,
    Tips,
    LoadingSpinner,
    TargetsModalProporsal,
    Step2SummaryToProporsal,
    Step2Summary,
    PreviewEmail,
    PreviewSequencesEmailProporsal,
    TargetStepCampaingPreviewProporsal,
  },
  props: {
    targetId: {
      type: String,
      required: true,
    },
    client: {
      type: Object,
      required: true,
      default: () => {},
    },
    specialOrderDiscountCountDown: {
      type: String,
      required: false,
      default: "",
    },
    toShowOpportunity: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    tabSelected(newVal, oldValue) {
      if (newVal == 4) {
        //this.loadingSequence = true;
        this.loading = true;
        //console.log("tab sequences...");
        this.loadCampaingStepTarget();
      }
    },
  },
  data() {
    return {
      modelCampaingStep: {
        campaign: {
          is_agency: 1,
        },
        campaign_steps: [],
        tabSelected: {
          id: 0,
          disabled: false,
        },
      },
      campaingTabSelectedId: 1,
      loading: false,
      loadingSequence: false,
      verificationOrder: [],
      targetDetailData: false,
      lang:'eng',
      apolloResult: false,
      step2sum: 2322,
      targetkey: 232232,
      select_offer_prospect: [
        {
          id: 1,
          label: this.$t("lang.onBoarding.offer_1"),
        },
        {
          id: 2,
          label: this.$t("lang.onBoarding.offer_2"),
        },
        {
          id: 3,
          label: this.$t("lang.onBoarding.offer_3"),
        },
        {
          id: 4,
          label: this.$t("lang.onBoarding.offer_4"),
        },
      ],
      salesSelected: [],
      salesRep: [],
      employess:[],
      categoryJobs:[],
      loadingSales: true,
      flags: [
        { id: "fr", lang_id: 1, text: "fr.svg" },
        { id: "en", lang_id: 2, text: "us.svg" },
        { id: "es", lang_id: 3, text: "es.svg" },
        { id: "it", lang_id: 4, text: "it.svg" },
        { id: "pt", lang_id: 5, text: "pt.svg" },
      ],
      langs: [
        {
          id: 5,
          type: "pt",
          label: this.$t("lang.onBoarding.lang.portugues"),
        },
        {
          id: 4,
          type: "it",
          label: this.$t("lang.onBoarding.lang.italian"),
        },
        {
          id: 3,
          type: "es",
          label: this.$t("lang.onBoarding.lang.spanish"),
        },
        {
          id: 2,
          type: "en",
          label: this.$t("lang.onBoarding.lang.english"),
        },
        {
          id: 1,
          type: "fr",
          label: this.$t("lang.onBoarding.lang.french"),
        },
      ],
      targetDetail: {},
      tabSelected: 1,
      editing: [],
      tabs: {
        1: {
          id: 1,
          name: this.$t("lang.orders.parameters"),
          paymentStatusId: 0,
        },
        2: {
          id: 2,
          name: this.$t("lang.orders.your_services"),
          paymentStatusId: 2,
        },
        3: {
          id: 3,
          name: this.$t("lang.orders.your_targeting"),
          paymentStatusId: 3,
        },
        4: {
          id: 4,
          name: this.$t("lang.orders.your_sequence"),
          paymentStatusId: 4,
        },
      },
    };
  },
  created() {
    this.getOrderDetail();

    if(this.toShowOpportunity){
      this.tabs = { 2: {
            id: 2,
            name: this.$t("lang.orders.your_services"),
            paymentStatusId: 2,
          }
      }
      this.tabSelected = 2
    }
  },
  mixins: [formattersMixin],
  computed: {
    ...mapState({
      availableTokens: (state) => state.optionsList.all["available_tokens"],
    }),

    flagActually() {
      return (id) => {
        if (id) {
          const flag = this.flags.find((e) => e.lang_id == id).text;
          return require("@/assets/images/flags/" + flag);
        } else {
          // if (this.onBoarding.lang != "") {
          //   const flag = this.flags.find(e => e.id === this.onBoarding.lang)
          //     .text;
          //   return require("@/assets/images/flags/" + flag);
          // } else {
          return require("@/assets/images/flags/fr.svg");
          //}
        }
      };
    },
    getLangSelected() {
      const lang = this.langs.find( e => e.id == this.targetDetail.language_id);
      return lang && lang.label ? lang.label : "";
    },
    getIdLangSelected() {
      const lang = this.langs.find( e => e.id == this.targetDetail.language_id);
      return lang && lang.id ? lang.id : 1;
    },
  },

  methods: {
    previewTemplate() {
      return true;
      return (
        (this.onBoarding.previewTemplate == 1 &&
          this.typeForm != "onboarding") ||
        this.currentUser.role_id == 1
      );
      // return (this.onBoarding.orderId == undefined || this.onBoarding.orderId == 0 || this.onBoarding.orderId > 810)
    },
    loadCampaingStepTarget() {
      let subjectFilter = {
        currentPage: 1,
        cantPerPage: 1,
        step: 1,
        campaign_step_template_type_id: 1,
        campaign_step_template_part_id: 2,
        isPreviewEmail: false,
        withTags: true,
        tag_id: this.targetDetail.tag_id,
        language_id: this.targetDetail.language_id,
      };
      proporsalService
        .loadCampaingStepTarget({ target_id: this.targetId })
        .then(async (res) => {
          this.loadingSequence = false;
          //console.log("loadCampaingStepTarget...", res);
          const hasSequenceCustom = res && res.length > 0 ? true : false;

          const targetIdAfterOpenAI =
            process.env.VUE_APP_ENV == "production" ? 2281 : 900;

          //console.log("targetIdAfterOpenAI", targetIdAfterOpenAI);

          const targetCreatedAfterOpenAI =
            this.targetId > targetIdAfterOpenAI ? true : false;
          const currentSequenceTypeOfTarget = this.targetDetail.sequence_type;

          // Si sequence_type No ES NULL
          if (currentSequenceTypeOfTarget) {
            //Si es una orden nueva (post secuencia openAI) // 2281
            // -- if (targetCreatedAfterOpenAI) state.tabs[2].disabled = true
            this.modelCampaingStep.tabSelected.id = currentSequenceTypeOfTarget;
            //console.log("has sequence_type", currentSequenceTypeOfTarget);
            //this.campaingTabSelectedId = currentSequenceTypeOfTarget
          } else {
            // Si sequence_type ES NULL

            //Si es una orden antes secuencia openAI)
            if (!targetCreatedAfterOpenAI) {
              //console.log("is old target...");
              //Si tengo respuesta con secuencia personalizada
              if (res.length > 0 && res) {
                this.modelCampaingStep.campaign_steps = res;
                this.modelCampaingStep.tabSelected.id = 1;
                state.sequence_type = 1;
              } else {
                // No tiene secuencia personalizada
                this.modelCampaingStep.tabSelected.id = 2;
                // state.sequence_type = 1
                // state.loading = false
              }
            } else {
              // es un target nuevo
              //console.log("is new target...");
              if (hasSequenceCustom) {
                this.modelCampaingStep.tabSelected.id = 1;
                state.sequence_type = 1;
              } else {
                this.modelCampaingStep.tabSelected.id = 3;
                // state.sequence_type = 3
                // state.tabs[2].disabled = true
              }
            }
          }

          if (hasSequenceCustom) {
            //console.log("hasSequenceCustom...");
            // ESTO ES CUANDO LA ORDEN TIENE SECUENCIA PERSONALIZADA .......
            this.modelCampaingStep.campaign_steps = res;
            //state.loading = false
          } else {
            //console.log("!hasSequenceCustom...");
            //state.modelCampaingStep.tabSelected.id = 2
            if (this.targetDetail.target_status_id != 3) {
              this.modelCampaingStep.tabSelected.disabled = true;
              //state.tabs[1].disabled = true
            }
            let subject = "";
            await proporsalService
              .getCampaignStepTemplates(subjectFilter)
              .then((resItem) => {
                subject =
                  resItem.list.length > 0 ? resItem.list[0].message : "";
              });
            for (let index = 1; index < 7; index++) {
              let searchFilter = {
                currentPage: 1,
                cantPerPage: 1,
                step: index,
                campaign_step_template_type_id: 1,
                campaign_step_template_part_id: 1,
                isPreviewEmail: false,
                withTags: true,
                tag_id: this.targetDetail.tag_id,
                language_id: this.targetDetail.language_id,
              };
              await proporsalService
                .getCampaignStepTemplates(searchFilter)
                .then((res) => {
                  this.modelCampaingStep.campaign_steps.push({
                    target_id: this.targetDetail.id,
                    step: index,
                    delay: index == 4 ? 30 : index > 1 ? 3 : 0,
                    time_to_send: "8",
                    subject: subject,
                    message: res.list[0].message,
                    recall_step: index == 4 ? 1 : 0,
                  });
                });
            }
            this.loading = false;
          }
        });
    },

    refreshTarget(result) {
      //(result)
      console.log(result)
      this.apolloResult = result;
      this.targetkey++;
    },
    disabledEdit() {
      return false;
    },
    getOrderDetail() {
      this.loading = true;
      proporsalService
        .getOrderDetail(this.targetId)
        .then((res) => {
          if (res.validation) {
            this.verificationOrder = res.validation;
            this.verificationOrder.target_id = this.targetId;
          }

          //res.data.target_id = 851
          //console.log(res)
          this.targetDetail = JSON.parse(JSON.stringify(res));
          this.employess = res.data.employees
          this.categoryJobs =JSON.parse(JSON.stringify(res.data.categories_jobs))
          //this.targetDetail.data.target_id = "1357"
          this.targetDetailData = true;
          this.salesRep = res.salesRep.map((el) => ({
            id: el.id,
            label: el.email,
          }));
          const emailsSales = res.salesSelected
            .filter((el) => el.target_id == this.targetId)
            .map((e) => e.email);

          res.salesRep.forEach((el) => {
            if (emailsSales.includes(el.email)) {
              this.salesSelected.push(el.id);
            }
          });
          let lang_id = res.language_id;
          if(lang_id == 1){
            this.lang = 'fr'
          }else{
            if(lang_id == 2){
              this.lang = 'eng'
            }else{
              this.lang = 'spa'
            }
          }

          //this.getApollo(data);
          this.loadingSales = false;
          this.loading = false;

          this.$emit('loadingCompleted')

        })
        .catch((err) => console.log(err));
    },
    changeTab(tab) {
      this.tabSelected = tab;
    },
    isOpen(type) {
      return this.editing[type] !== undefined && this.editing[type] == true;
    },
    changeLanguage(save) {
      let language_id;
      language_id = 1;
      if (this.onBoarding.lang == "fr") {
        language_id = 1;
      }
      if (this.onBoarding.lang == "en") {
        language_id = 2;
      }
      if (this.onBoarding.lang == "es") {
        language_id = 3;
      }
      if (this.onBoarding.lang == "it") {
        language_id = 4;
      }
      if (this.onBoarding.lang == "pt") {
        language_id = 5;
      }

      this.setLanguageId(language_id);
      if (save) {
        this.closeEdit("language");
      }
    },
  },
};
</script>

<style scoped>
.btn_pause {
  background-color: #ffc107;
}
.bg-paused {
  background-color: #fefcdd;
  border: 3px solid #faf879;
  color: #abaaa3;
  font-weight: 700;
}

.text-size-14 {
  font-size: 14px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.border-style-dashed {
  border-style: dashed;
  border-bottom: 1px dashed;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
}
.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 11px;
}

.bg-custon-gray {
  background-color: #f1f1fd;
}

.circle-custom {
  border-radius: 100%;
  width: 70px;
  height: 70px;
  border: 6px;
}

.border-custom-right {
  border-right: 7px solid blue;
  height: 36px;
}

.border-custom-right-hide {
  height: 36px;
}

.content-center {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
